'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _ListElementPresentational = require('./ListElementPresentational');

var _ListElementPresentational2 = _interopRequireDefault(_ListElementPresentational);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


var ListElementContainer = function (_React$Component) {
    _inherits(ListElementContainer, _React$Component);

    function ListElementContainer(props) {
        _classCallCheck(this, ListElementContainer);

        var _this = _possibleConstructorReturn(this, (ListElementContainer.__proto__ || Object.getPrototypeOf(ListElementContainer)).call(this, props));

        _this.getRange = _this.getRange.bind(_this);
        return _this;
    }

    /**
     * Register the list element with the parent on mount.
     */


    _createClass(ListElementContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var registerListElement = this.props.registerListElement;

            registerListElement && registerListElement(this);
        }

        /**
         * Remove the list element from the parent when un-mounting.
         */

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var deregisterListElement = this.props.deregisterListElement;

            deregisterListElement && deregisterListElement(this);
        }

        /**
         * Retrieves the vertical point within the list that this index covers.
         *
         * @returns {Number} The vertical point within the list that determines whether the index should
         *              be more than the current index.
         */

    }, {
        key: 'getRange',
        value: function getRange() {
            var domNode = (0, _reactDom.findDOMNode)(this);
            // Get vertical middle
            return domNode.offsetTop + domNode.offsetHeight / 2;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_ListElementPresentational2.default, this.props);
        }
    }]);

    return ListElementContainer;
}(_react2.default.Component);

ListElementContainer.propTypes = {
    element: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    connectDropTarget: _propTypes2.default.func,
    registerListElement: _propTypes2.default.func,
    deregisterListElement: _propTypes2.default.func
};

exports.default = ListElementContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/ListElementContainer.js
// module id = 2034
// module chunks = 0